/** Shared max-width for admin entity show/edit field stacks. */
export const adminEntityFieldsMaxWidthSx = {
  maxWidth: { md: "50%", xs: "100%" },
} as const
